<template>
  <div id="personal_home_page_outer" v-if="user != null">
    <div id="personal_home_page_left" :class="[borderColor]">
      <div style="position: relative;" @mouseenter="headerShow" @mouseleave="headerHide">
        <img id="personal_home_page_user_img" :class="borderColor" :src="headIcon">
        <div class="header-fore-div" v-if="showHeadImgForDiv" @click="headIconClicked">
          <span class="iconfont" style="color: white;font-size: 2rem;">&#xe672;</span>
        </div>
      </div>

      <div class="personal_home_page_label_1">您好</div>
      <div class="personal_home_page_left_name">{{user.nickname}}</div>

      <div class="personal_home_page_label_2">我的信息完整度</div>
      <div id="person_home_page_stars_out">
        <img
          v-for="index in [1,2,3,4,5]"
          :src="starValue >= index ? selectedStarImg : normalStarImg"
          :key="'personal_home_page_star_' + index"
        >
      </div>

      <div class="personal_home_page_label_3" >{{starValue == 5 ? '太棒了，获得5星！' : '立即完善信息，提升我的信息完整度！'}}</div>
    </div>
    <div id="personal_home_page_right" :class="[borderColor]">
      <div id="personal_user_info" >
        <div>
          <div class="user_info_head_edit">
            <div :class="['personal_home_right_title', textColor]">我的信息</div>
            <a href="javascript:void(0);"
               style="padding: 5px;margin-left:5px;"
               @click="beginEditing"
            ><img v-show="isEdting == false" :src="editImg" style="width: 15px; height: auto;" ></a>
          </div>
          <div>
            <input v-show="isEdting == true" id="personal_form_cancel"
                   type="button"
                   value="取消"
                   @click="submitCancel"
            >
            <input v-show="isEdting == true" id="personal_form_submit"
                   type="button"
                   value="提交"
                   :class="[borderColor, textColor]"
                   @click="submitUserEdit"
            >
          </div>

        </div>
        <div id="user_info_display" v-if="isEdting == false">
          <div>
            <div class="user_info_ul">
              <div class="user_info_label">姓名：</div>
              <div class="user_info_text">{{(user.name != null && user.name.length > 0) ? user.name : user.nickname}}</div>
            </div>

            <div class="user_info_ul" v-if="user.isMember == 1">
              <div class="user_info_label">类型：</div>
              <div class="user_info_text">{{personTypeText}}</div>
            </div>

            <div class="user_info_ul">
              <div class="user_info_label">性别：</div>
              <div class="user_info_text" >{{genderText}}</div>
            </div>

            <div class="user_info_ul">
              <div class="user_info_label">出生日期：</div>
              <div class="user_info_text">{{birthdayText}}</div>
            </div>

            <div class="user_info_ul">
              <div class="user_info_label">所在地区：</div>
              <div class="user_info_text">{{(user.area == null || user.area.length == 0)? '暂无' : user.area}}</div>
            </div>
          </div>
          <div>
            <div class="user_info_ul">
              <div class="user_info_label">个人介绍：</div>
              <div class="user_info_profile">{{(user.desc == null || user.desc.length == 0) ? '暂无' : user.desc}}</div>
            </div>

          </div>

        </div>

        <div id="user_info_edit" v-else>
          <div>
            <div class="user_info_ul">
              <div class="user_info_label">姓名：</div>
              <input :class="[borderColor, 'user_info_input']"
                     :disabled="!userNameInputAbled"
                     type="text" name="username"
                     v-model="userName"
                     placeholder="请输入姓名">
            </div>

            <div class="user_info_ul" v-if="user.isMember == 1">

              <div class="user_info_label">类型：</div>
              <div class="user_info_text">{{personTypeText}}</div>
              <div style="width: 60%;">
<!--                <select :class="[borderColor, 'user_info_input']"-->
<!--                        v-model="userType"-->
<!--                        style="width: 100%;"-->
<!--                >-->
<!--                  <option v-for="item in persontypeList" :value="item.value" v-text="item.title" />-->
<!--                </select>-->

                <input
                  :class="[borderColor, 'user_info_input']"
                  style="margin-top: 10px;width: 100%;"
                  type="text"
                  v-if="false"
                  placeholder="请输入具体名称"
                  v-model="userTypeDesc"
                >
              </div>
            </div>

            <div class="user_info_ul">
              <div class="user_info_label">性别：</div>
              <select :class="[borderColor, 'user_info_input']" name="gender" v-model="userSex">
                <option
                  v-for="item in genderOptionList"
                  :value="item.value"
                >{{item.title}}</option>

              </select>
            </div>

            <div class="user_info_ul">
              <div class="user_info_label">年龄：</div>
              <date-picker :format="'yyyy-MM-dd'"
                           v-model="birthday"
                           style="width: 60%;"
                           :placeholder="'请输入生日'"
                           :language="zh"
                           :input-class="[borderColor, 'date-input-class']"
              ></date-picker>
            </div>

            <div class="user_info_ul">
              <div class="user_info_label" style="width: 80px;">所在地区：</div>
              <v-distpicker
                style="width: 80%"
                :province="userArea.province"
                :city="userArea.city"
                :area="userArea.area"
                @selected="areaSelected"
                :wrapper="dispatcherWrapperClass"
              />
            </div>

          </div>
          <div>
            <div class="user_info_ul">
              <div class="user_info_label">个人简介：</div>
              <textarea class="user_info_textarea" maxlength="200" name="profile" placeholder="介绍一下你自己，限定200字以内哦！" v-model="userDesc"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div id="personal_user_vips_info" >
        <div :class="['personal_home_right_title', textColor]">我的会员</div>
        <div v-if="user.isMember == 1" style="margin-top: 20px;">
          <div v-if="memberValid == true" style="font-size: 1rem;color: #111;">已成为认证会员</div>
          <div v-if="memberValid == true" style="font-size: 1rem;color: #111;">会员有效期至{{memberValidDateText}}</div>
          <div v-else style="font-size: 1rem;color: #111;">会员已过期<a v-if="isCanVipOperated && isOfficialOpened" href="javascript:void(0)" @click="gotoVipApplicationPage" style="text-decoration: none;margin-left: 5px;">前往年审>>></a> </div>
        </div>
        <div v-else style="margin-top: 15px;">
          <div style="font-size: 1rem;color: #111;">尚未成为认证会员，
            <a href="/introduce/0203" style="text-decoration: none;">什么是协会会员？</a> <br>
            <a v-if="isCanVipOperated && isOfficialOpened" href="javascript:void(0)" @click="gotoVipApplicationPage" style="text-decoration: none;margin-top: 5px;display: inline-block;" >立即申请>>></a>
          </div>
        </div>
      </div>
      <div style="margin-top: 15px;position: relative;" v-if="completedJudgeList != null">
        <div :class="['personal_home_right_title', textColor]">我的认证</div>

        <div style="margin-top: 10px;" v-if="completedJudgeList.length == 0 && completedCoachItem == null">
          尚未认证教练/裁判职业身份，<a href="javascript:void(0)"  style="text-decoration: none;" @click="showApplySelectView">立即认证>></a>
        </div>

        <div v-else-if="completedJudgeList.length > 0">
          <div class="referee-info-item" v-for="(item, index) in completedJudgeList" :key="'referee_item_' + index">
            <div class="sub-title">{{ item.certificateLevel + '裁判员' }}</div>
            <div>
              <span v-if="isJudgeSuccess(item)" class="success-label">本年度年检合格</span>
            <a v-if="showYearCheck(item)" style="text-decoration: none; color: #e71432;" href="javascript:void(0)" @click="gotoCertCheckPage(item.id)">立即年检</a>
            </div>
          </div>

          <div v-if="completedCoachItem != null" class="referee-info-item" >
            <div class="sub-title">{{ completedCoachItem.certificates[0].level + '教练员' }}</div>
            <div>
              <span style="display: inline-block;padding: 0;padding-top: 2.5px;">{{getCoachValidDate(completedCoachItem)}}</span>
              <!-- <span class="success-label">认证有效期内</span> -->
              <a v-if="!isCoachSuccess(completedCoachItem)" style="text-decoration: none; color: #e71432;" href="javascript:void(0)" @click="gotoCoachCheckPage(completedCoachItem.coach.id)">立即年检</a>
            </div>
          </div>

          <div v-else style="margin-top: 10px;">
            尚未认证教练职业身份，<a href="javascript:void(0)"  style="text-decoration: none;" @click="gotoCoachCheckPage(0)">立即认证>></a>
          </div>
        </div>


        <div v-else>
          <div class="referee-info-item" >
            <div class="sub-title">{{ completedCoachItem.certificates[0].level + '教练员'}}</div>
            <div>
              <span style="display: inline-block;padding: 0;padding-top: 2.5px;" >{{getCoachValidDate(completedCoachItem)}}</span>
              <!-- <span v-if="isCoachSuccess(completedCoachItem)" class="success-label">认证有效期内</span> -->
              <a v-if="!isCoachSuccess(completedCoachItem)" style="text-decoration: none; color: #e71432;" href="javascript:void(0)" @click="gotoCoachCheckPage(completedCoachItem.coach.id)">立即年检</a>
            </div>
          </div>

          <div v-if="isOfficialOpened" style="margin-top: 10px;">
            尚未认证裁判职业身份，<a href="javascript:void(0)"  style="text-decoration: none;" @click="gotoCertCheckPage(0)">立即认证>></a>
          </div>
          <div v-else style="margin-top: 10px;">
            尚未认证裁判职业身份，认证开放时间等消息可关注<a href="/training" target="_blank" style="text-decoration: none;">篮球培训</a>版块获取
          </div>
        </div>


      </div>
      
      <apply-dialog v-if="showApplyDialog"
      :refereeAble="isOfficialOpened"
      v-on:applyCheck="selectApplicationItem"
      v-on:close="showApplyDialog = false"></apply-dialog>
    </div>

    <headportrait-select v-if="showHeadportraitEditing" @close="closeHeadportraitSelect" />
<!--    <image-test v-if="showHeadportraitEditing" />-->

  </div>
</template>

<script>
import NormalStarImg from '../../assets/shl_home_page_star_normal.png';
import SelectdStarImg from '../../assets/shl_home_page_star_selected.png';
import RedNormalStarImg from '../../assets/shl_home_page_red_star_normal.png';
import RedSelectedStarImg from '../../assets/shl_home_page_red_star_selected.png';
import GoldEditImg from '../../assets/shl_editing_gold_img.png';
import RedEditImg from '../../assets/shl_editing_red_img.png';
import VDistpicker from 'v-distpicker';
import DatePicker from 'vuejs-datepicker';
import Lzh from "vuejs-datepicker/dist/locale/translations/zh";

import HeadRedImage from '../../assets/shl_personal_head_portrait_red_default.png';
import HeadGoldImage from '../../assets/shl_personal_head_portrait_gold_default.png';
import HeadportraitSelect from "../HeadportraitSelect/HeadportraitSelect";

import ImageTest from "../vue-clip/ImageTest";

import ApplyDialog from "./children/ApplyDialog.vue";
import HardwareManager from "../../js/hardware-check.js";

export default {
  name: "PersonalHomePage",
  components: {
    VDistpicker,
    DatePicker,
    HeadportraitSelect,
    ImageTest,
    ApplyDialog,
  },
  data() {
    return {
      title: '我的主页',
      goldStar: {
        normStarImg: NormalStarImg,
        selectedStarImg: SelectdStarImg,
      },
      redStar: {
        normStarImg: RedNormalStarImg,
        selectedStarImg: RedSelectedStarImg,
      },
      isEdting: false,
      showHeadportraitEditing: false,
      isSupportedCamera: null,

      persontypeList: [
        {
          title: '教练员',
          value: 1,
        },
        {
          title: '裁判员',
          value: 2,
        },
        {
          title: '其他',
          value: 0,
        },
      ],

      genderOptionList: [
        {
          title: '保密',
          value: 0
        },
        {
          title: '男',
          value: 1
        },
        {
          title: '女',
          value: 2
        },
      ],

      zh: Lzh,

      userName: null,
      userSex: null,
      birthday: null,
      userArea: {
        province: '',
        city: '',
        area: '',
      },
      userDesc: null,
      userType: null,
      userTypeDesc: '',
      showHeadImgForDiv: false,
      completedJudgeList: null,
      uncompletedJudgeList: null,
      judgeApplyDuration: null,
      judgeList: null,
      completedCoachItem: null,
      incompletedCoachItem: null,

      showApplyDialog: false,
      applyForm: {

      }
    }
  },

  mounted() {
    let _this = this;
    HardwareManager.isSupportCamera(function(isSupported) {
      _this.isSupportedCamera = isSupported;
    });

    $(window).resize(this.updateElements);
    this.updateElements();
    this.getJudgeIdentificationDateDuration();
    this.loadJudgeListData();
    this.getCoachData();
  },

  computed: {
    user() {
      return this.$store.state.user;
    },

    myJudgeList() {
      return this.$store.state.judgeList;
    },

    httpManager() {
      return this.$store.state.http;
    },

    typeNameAllowedList() {
      return this.$store.state.typeNameAllowedList
    },
    isCanVipOperated() {
      let user = this.user;
      if (user == null) {
        return false;
      }
      let typeName = user.typeName;
      if (typeName == null || typeName == '' || this.typeNameAllowedList.indexOf(typeName) >= 0) {
        return true;
      }
      return false;
    },

    isOfficialOpened() {
      let judgeApplyDuration = this.judgeApplyDuration;
      if (judgeApplyDuration == null) {
        return false;
      }
      let beginString = judgeApplyDuration.begin;
      let enditString = judgeApplyDuration.end;
      let beginDate = this.$moment(beginString);
      let endDate = this.$moment(enditString);
      let now = this.$moment(this.$moment().format("yyyy-MM-DD"), "yyyy-MM-DD");
      if ((now - beginDate) >= 0 && (now - endDate) <= 0) {
        return true;
      }
      return false;
    },

    isVip() {
      if (this.user == null) {
        return false;
      }
      let user = this.user;
      let memberValidDate = user.memberValidDate;
      if (memberValidDate == null) {
        return false;
      }
	  return this.$moment(memberValidDate).add('1','days').add('-1', 'seconds').isAfter(this.$moment());
    },

    userNameInputAbled() {
      if (this.user == null) {
        return true;
      }
      return (this.user.isIdentification > 0);
    },

    themeValue() {
      return this.isVip ? 1 : 0;
    },
    dispatcherWrapperClass() {
      return this.themeValue == 0 ? 'area-dispatcher-red' : 'area-dispatcher-gold';
    },
    personTypeText() {
      return (this.user.typeName == null || this.user.typeName.length == 0) ? '暂无' : this.user.typeName;

      let type = this.user.type;
      if (type == undefined || type == null) {
        return '暂无';
      }
      if (type == 0) {
        return (this.user.typeName == null || this.user.typeName.length == 0) ? '暂无' : this.user.typeName;
      }

      if (type == 1) {
        return '教练员';
      } else if (type == 2) {
        return '裁判员';
      } else {
        return '类型错误 : ' + type;
      }
    },
    userHeadDefault() {
      return this.isVip ? HeadGoldImage : HeadRedImage;
    },
    starValue() {
      let value = 0;
      let user = this.user;
      let name = user.name;
      if (name != null && name.length > 0) {
        value ++;
      }

      let desc = user.desc;
      if (desc != null && desc.length > 0) {
        value ++;
      }

      let birthday = user.birthday;
      if (birthday != null && this.$moment(birthday).isValid()) {
        value ++;
      }

      let sex = user.sex;
      if (sex != null) {
        value ++;
      }

      let area = user.area;
      if (area != null && area.length > 0) {
        value ++;
      }
      return value;
    },
    normalStarImg() {
      return this.themeValue == 0 ? this.redStar.normStarImg : this.goldStar.normStarImg;
    },
    selectedStarImg() {
      return this.themeValue == 0 ? this.redStar.selectedStarImg : this.goldStar.selectedStarImg;
    },
    borderColor() {
      return this.themeValue == 0 ? 'border-red-color' : 'border-gold-color';
    },
    textColor() {
      return this.themeValue == 0 ? 'shba-no-vips-color' : 'shba-vips-color';
    },
    editImg() {
      return this.themeValue == 0 ? RedEditImg : GoldEditImg;
    },
    specBackgroundColor() {
      return this.themeValue == 0 ? 'background-red-color' : 'background-gold-color'
    },
    headIcon() {
      if (this.user == null || this.user.headPortrait == null) {
        return this.userHeadDefault;
      } else  {
        return this.user.headPortrait
      }
    },
    genderText() {
      let user = this.user;
      let sex = user.sex;
      if (sex == null) {
        return '暂无';
      }
      return sex == 0 ? '保密' : (sex == 1 ? '男' : '女');
    },
    memberValid() {
      if (this.user == null || this.user.memberValidDate == null || this.user.memberValidDate.length > 0){
        return false;
      }

      let validDate = new Date(this.user.memberValidDate);
      let now = new Date();
      let inetrval = validDate - now;
      return inetrval > 0;
    },
    memberValidDateText() {
      if (this.user == null || this.user.memberValidDate == null || this.user.memberValidDate.length > 0){
        return '暂无';
      }
      return this.$moment(this.user.memberValidDate).format('yyyy年MM月DD日');
    },

    birthdayText() {
      let birthDay = this.user.birthday;
      if (birthDay == null || !this.$moment(birthDay).isValid()) {
        return '暂无';
      }
      return this.$moment(birthDay).format('yyyy年MM月DD日');
    },
  },
  watch: {
    myJudgeList: {
      handler(val, oldVal) {
        console.log('judge list update');
        this.loadJudgeListData();
      },
      deep: true
    },
  },
  methods: {
    getCoachValidDate(item) {
      if (item == null) {
        return '';
      }
      let auditTime = item.coach.auditTime;
      if (auditTime == null || auditTime == '') {
        return '';
      }
      let date = this.$moment(auditTime).add(2, 'years');
      let now = this.$moment();
      if (date - now > 10) {
        return '有效期至' + date.format('yyyy年MM月DD日');
      } else {
        return '认证已过期';
      }
    },

    selectApplicationItem(res) {
      let item = res.item;
      console.log(res);
      console.log(item);
      if (item == 'judge') { // 裁判员
        this.gotoCertCheckPage(0);
        return;
      }

      if (item == 'coach') { // 教练员
        this.gotoCoachCheckPage(0);
        return;
      }
    },

    gotoVipApplicationPage() {
      this.$router.push({
        name: 'personalApplicationVue'
      });
    },
    getCoachData() {
      let coachList = this.$store.state.coachData;
      if (coachList == null) {
        let _this = this;
        setTimeout(function() {
          _this.getCoachData();
        }, 100);
        return;
      }

      if (coachList.length == 0) {
        return;
      }

      for(let i = 0; i < coachList.length; i++) {
        let item = coachList[i];
        let coach = item.coach;
        if (coach.status == 7) {
          this.completedCoachItem = item;
        } else {
          this.incompletedCoachItem = coach;
        }
      }
    },

    getJudgeIdentificationDateDuration() {
      let judgeApplyDuration = this.judgeApplyDuration;
      if (judgeApplyDuration == null) {
        let _this = this;
        this.httpManager.ajax.getJudgeApplyDateData(function (data) {
          if (data.code == 0) {
            let value = data.data.value;
            let duration = JSON.parse(value);
            _this.judgeApplyDuration = duration;
            _this.dealWithJudgeList();
            return;
          }
        }, function (data) {

        });
      }
    },
    showApplySelectView() {
      this.showApplyDialog = true;
    },

    gotoCoachCheckPage(id) {
      let isSupportedCamera = this.isSupportedCamera;
      if (isSupportedCamera == null) {
        let _this = this;
        setTimeout(function() {
          _this.gotoCoachCheckPage(id);
        },100);
        return;
      }

      if (isSupportedCamera == false) {
        this.$confirm("该认证需要人脸识别，检测到您的设备未安装或开启摄像头，请开启或更换设备后重试。");
        return;
      }

      let certId = id;
      if (certId == 0) {
        if (this.incompletedCoachItem != null) {
          certId = this.incompletedCoachItem.id;
        }
      }

      this.$router.push({
        name: 'personalCoachCertApplicationVue',
        params: {
          certId: certId,
        }
      })
    },

    gotoCertCheckPage(id) {
      let isSupportedCamera = this.isSupportedCamera;
      if (isSupportedCamera == null) {
        let _this = this;
        setTimeout(function() {
          _this.gotoCertCheckPage(id);
        },100);
        return;
      }

      if (isSupportedCamera == false) {
        this.$confirm("该认证需要人脸识别，检测到您的设备未安装或开启摄像头，请开启或更换设备后重试。");
        return;
      }

      let certId = id;
      if (certId == 0) {
        if (this.uncompletedJudgeList.length > 0) {
          certId = this.uncompletedJudgeList[0].id;
        }
      }

      this.$router.push({
        name: 'personalCertificateApplicationVue',
        params: {
          certId: certId,
        }
      })
    },

    showYearCheck(item) {
      if (item == null) {
        return false;
      }

      if (item.auditStatus == 1) {
        return true;
      } else  {
        let allowed = this.isOfficialOpened;
        if (allowed && item.reviewed == 0) {
          return true
        }
        return false;
      }
    },

   isCoachSuccess(item) {
     let coachData = item;
     let coach = coachData.coach;
     if (coach == null) {
       return null;
     }
     let auditTime = coachData.coach.auditTime;
     if (auditTime == null || auditTime == '') {
       return false;
     } else {
       let date = this.$moment(auditTime).add(2, 'years');
       let now = this.$moment();
       if (date - now > 0) {
         return true;
       } else {
         return false;
       }
     }
   },

    isJudgeSuccess(item) {
      if (item != null) {
        console.log('---1');
        console.log(item);
        if (item.auditStatus == 1) { // 在年检中
          let staminaTest = item.staminaTest;
          if (staminaTest == null) {
            staminaTest = '未进行';
          }
          let theoryTest = item.theoryTest;
          if (theoryTest == null) {
            theoryTest = '未进行';
          }
          if (item.status == 5 && theoryTest == '已通过' && staminaTest == '已通过') {
            return true;
          }
        } else { // 非年检中
          if (item.reviewed != 0 && item.status == 6) {
            return true;
          }
        }
      }
      return false;
    },

    updateElements() {
      let windowWidth = window.innerWidth;
      if (windowWidth >= 768) {
        let interval = setInterval(function () {
          let leftDiv = document.getElementById("personal_home_page_left");
          let rightDiv = document.getElementById("personal_home_page_right");
          if (leftDiv && rightDiv) {
            let leftHeight = leftDiv.offsetHeight;
            let rightHeight = rightDiv.offsetHeight;
            if (leftHeight == rightHeight) {
              clearInterval(interval);
              return;
            }
            let height = leftHeight > rightHeight ? leftHeight : rightHeight;
            leftDiv.style.height = rightDiv.style.height = height + 'px';
          }
        }, 1000);
      }

    },
    headerShow() {
      this.showHeadImgForDiv = true;
    },
    headerHide() {
      this.showHeadImgForDiv = false;
    },
    beginEditing() {
      this.userName = ((this.user.name == null || this.user.name.length == 0) ? this.user.nickname : this.user.name);
      this.userSex = (this.user.sex == null ? 0 : this.user.sex);
      this.birthday = (this.user.birthday == null ? '' : this.user.birthday);
      this.userDesc = (this.user.desc == null ? '' : this.user.desc);
      this.userType = this.user.type;
      this.userTypeDesc = (this.user.typeName == null) ? '' : this.user.typeName;

      if (this.user.area == null) {
        this.userArea = {
          province: '',
          city: '',
          area: '',
        };
      } else {
        let area = this.user.area;
        let areaList = area.split(',');
        let tempObj = {};
        if (areaList.length > 0) {
          tempObj.province = areaList[0];
          tempObj.city = areaList[1];
          tempObj.area = areaList[2];
          this.userArea = tempObj;
        } else {
          this.userArea = {
            province: '',
            city: '',
            area: '',
          };
        }
      }
      this.isEdting = true;

    },
    areaSelected(data) {
      this.userArea.province = data.province.value;
      this.userArea.city = data.city.value;
      this.userArea.area = data.area.value;
    },
    typeName(type) {
      let list = this.persontypeList;
      let typeName = '';

      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (item.value == type) {
          typeName = item.title;
          break;
        }
      }
      return typeName;
    },
    submitCancel() {
      this.isEdting = false;
    },
    submitUserEdit() {
      let name = this.userName.removeBlanks();

      let birthday = '';
      if (this.$moment(this.birthday).isValid()) {
        birthday = this.$moment(this.birthday).format('yyyy-MM-DD');
      }

      let sex = this.userSex;
      let desc = this.userDesc;
      let area = null;
      if (this.userArea.province != '') {
        area = this.userArea.province + ',' + this.userArea.city + ',' + this.userArea.area;
      }
      let params = {
        name,
        sex,
        sBirthday: birthday,
        desc,
        area,
        flag: 0
      }
      if (this.user.isMember == 1) {
        let type = this.userType;
        let typeName = this.userTypeDesc.removeBlanks();
        if (type != 0) {
          typeName = this.typeName(type);
        } else if (typeName == '') {
          this.$toast('请输入类型名称！');
          return;
        }
        params.type = type;
        params.typeName = typeName;
      }

      //
      let _this = this;
      this.$store.state.http.ajax.ucProfileUpdate(params, function (data) {

        if (data.code == 0) {
          _this.$toast('提交成功');
          _this.$router.go(0);
        } else {
         _this.$toast('提交失败');
        }
      },function (data) {
        _this.$toast('提交失败，请重试！');
      });
    },
    closeHeadportraitSelect() {
      this.showHeadportraitEditing = false;
    },
    headIconClicked() {
      this.showHeadImgForDiv = false
      this.showHeadportraitEditing = true;
    },


    loadJudgeListData() {
      let judgeList = this.$store.state.judgeList;
      if (judgeList == null) {

        let _this = this;
        setTimeout(function () {
          _this.loadJudgeListData();
        }, 50);

        return;
      }

      this.judgeList = judgeList;
      this.dealWithJudgeList();


      // return;

      // let _this = this;
      // this.httpManager.ajax.getJudgeListSelfData(function (data) {
      //   let code = data.code;
      //   if (code == 0) {
      //     let judgeList = data.data;
      //     _this.judgeList = judgeList;
      //     _this.dealWithJudgeList();
      //     return;
      //   }
      // }, function () {
      // });
    },

    dealWithJudgeList() {
      if (this.judgeList == null || this.judgeApplyDuration == null) {
        return;
      }
      let allowed = this.isOfficialOpened;

      let judgeList = [];
      if (this.judgeList.length > 0) {
        judgeList.push(this.judgeList[0]);
      }

      let completedArray = [];
      let unCompletedArray = [];
      if (judgeList.length > 0) {
        for (let i = 0; i < judgeList.length; i++) {
          let item = judgeList[i];
          let updatedTime = item.updatedTime;
          if (updatedTime != null) {
            let number =  this.$moment().year() - this.$moment(updatedTime).year();
            if (number > 1) {
              continue;
            }
          }

          if (item.status >= 5 && item.status < 7) {
            completedArray.push(item);
          } else if (item.reviewed == 0) {
            completedArray.push(item);
          }

          if (item.auditStatus == 1) {
            unCompletedArray.push(item);
          }
        }
      }
      this.completedJudgeList = completedArray;
      this.uncompletedJudgeList = unCompletedArray;
    }
  }
}
</script>

<style>
  #personal_home_page_outer .date-input-class {
    color: #333;
    height: 30px;
    width: 100%;
    text-indent: 10px;
    text-align: left;
    border-radius: 4px;
  }

  #personal_home_page_outer .border-red-color {
    border: solid 1px #e71432;
  }

  #personal_home_page_outer .border-gold-color {
    border: solid 1px #cbb042;
  }

  .area-dispatcher-red, .area-dispatcher-gold {
    width: 100%;
  }


  .area-dispatcher-red label, .area-dispatcher-gold label {
    height: 30px;
    width: 32%;
    min-width: 70px;
  }

  .area-dispatcher-red label select {
    height: 100%;
    width: 100%;
  }

  .area-dispatcher-gold label select {
    height: 100%;
    width: 100%;
    border: solid 1px #cbb042;
    border-radius: 4px;
  }

</style>

<style scoped>

  #personal_home_page_outer {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    padding-bottom: 30px;
    padding-left: 5px;
    padding-right: 5px;
    position: relative;
  }

  #personal_home_page_outer > div {
    min-height: 500px;
  }

  #personal_home_page_left {
    width: 100%;
    min-width: 260px;
    margin-top: 30px;
    padding-top: 65px;
    padding-bottom: 65px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
  }

  #personal_home_page_right {
    padding: 40px 5% 40px 5%;
    width: 100%;
    margin-top: 30px;
    min-width: 260px;
    position: relative;
    /*background-color: yellow;*/
  }

  #user_info_display > div, #user_info_edit > div {
    width: 100%;
  }


  #personal_home_page_user_img {
    width: 120px;
    height: 120px;
    background-color: white;
    border-radius: 60px;
  }


  .personal_home_page_label_1 {
    font-size: 1rem;
    color: #333;
    margin-top: 20px;
  }

  .personal_home_page_left_name {
    font-size: 1.5rem;
    color: #333;
  }

  .personal_home_page_label_2 {
    font-size: 0.8rem;
    color: #999;
    letter-spacing: 3px;
    margin-top: 30px;
  }

  .personal_home_page_label_3 {
    font-size: 1rem;
    color: #999;
    margin-top: 50px;
  }

  #person_home_page_stars_out {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }

  #person_home_page_stars_out img {
    width: 21px;
    height: 21px;
    margin-left: 5px;
  }

  #person_home_page_stars_out img:first-child {
    margin-left: 0;
  }

  .personal_home_right_title {
    font-size: 1.5rem;
    font-weight: bold;
  }

  .person_infor_table {
  }
  .person_infor_table th, .person_infor_table td {
    border: none;
    font-size: 1.2rem;
    text-align: left;
    padding-left: 0;
    padding-right: 0;
  }

  .person_infor_table th {
    width: 8rem;
  }

  .person_infor_table td {
  }

  .table_li_text {
    font-size: 1.2rem;
    color: #333;
    padding-top: 5px;
  }

  .border-red-color {
    border: solid 1px #e71432;
  }

  .border-gold-color {
  border: solid 1px #cbb042;
  }

  .background-red-color {
    background-color: #e71432;
  }

  .background-gold-color {
    background-color: #cbb042;
  }

  #personal_user_info > div:first-child {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    /*background-color: yellow;*/
  }

  .user_info_head_edit {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  }

  #user_info_display, #user_info_edit {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .user_info_ul {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
  }

  #user_info_edit .user_info_ul {
    margin-top: 10px;
  }

  .user_info_label {
    font-size: 1rem;
    color: #111;
    text-align: left;
    width: 80px;
    letter-spacing: 1.5px;
    align-self: flex-start;
  }

  .user_info_text {
    font-size: 1rem;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    max-width: 67%;
  }

  .user_info_profile {
    font-size: 1rem;
    color: #666;
    max-width: 80%;
  }

  #personal_user_vips_info {
    margin-top: 30px;
  }


  #personal_form_cancel {
    font-size: 1rem;
    background-color: white;
    height: 30px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 15px;
    outline: none;
    border: solid 1px #aaa;
    color: #aaa;
    margin-right: 10px;
  }


  #personal_form_submit {
    font-size: 1rem;
    background-color: white;
    height: 30px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 15px;
    outline: none;

  }

  #user_info_edit .user_info_label {
    margin-top: 5px;
  }

  .user_info_input {
    color: #666;
    border: solid 1px #ccc;
    background-color: white;
    font-size: 1rem;
    height: 30px;
    border-radius: 4px;
    text-indent: 15px;
    width: 60%;
  }

  .user_info_textarea {
    color: #666;
    border: solid 1px #ccc;
    background-color: white;
    font-size: 1rem;
    padding: 5px;
    width: 60%;
    height: 120px;
  }

  @media screen and (min-width: 645px){
    .user_info_profile {
      font-size: 1rem;
      color: #666;
      max-width: 70%;
    }
  }

  @media screen and (min-width: 768px) {

    #personal_home_page_outer {
      justify-content: space-between;
    }

    #personal_home_page_left {
      width: 40%;
    }

    #personal_home_page_right {
      width: 55%;
      padding: 40px 30px 70px 30px;
    }
  }


  @media screen and (min-width: 1120px) {
    #user_info_display > div:first-child, #user_info_edit > div:first-child {
      width: 60%;
    }

    #user_info_display > div:last-child, #user_info_edit > div:last-child {
      width: 40%;
    }

    #user_info_display > div:last-child .user_info_profile, #user_info_edit > div:last-child .user_info_profile {
      max-width: 70%;
    }
  }

  .header-fore-div {
    background-color: rgba(0,0,0,0.3);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    border-radius: 60px;
    line-height: 120px;
    text-align: center;
  }

  #personal_home_page_outer .referee-info-item {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    max-width: 400px;
  }

  #personal_home_page_outer .referee-info-item:first-child {
    margin-top: 7px;
  }

  #personal_home_page_outer .referee-info-item .sub-title {
    font-size: 15px;
  }

  #personal_home_page_outer .referee-info-item:not(:first-child) {
    margin-top: 1px;
  }

  .referee-info-item > div:first-child {
    font-size: small;
    padding-top: 3px;
  }

  .referee-info-item > div:not(:first-child) {
    font-size: small;
    margin-left: 10px;
  }

  #personal_home_page_outer .success-label {
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
    color: green;
    border: solid 1px green;
    padding: 0 3px;
  }


  @media screen and (min-width: 320px) {
    .referee-info-item > div:first-child {
      font-size: 1rem;
    }

    .referee-info-item > div:not(:first-child) {
      font-size: 1rem;
      margin-left: 15px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/personal/PersonalHomePage.vue